import React, { useEffect, useState } from "react";
import ProductListing from "./ProductListing";
import { postData1 } from "../../../services";
import { Pagination } from "../../Common";

const OrderHistoryList = ({ userUid }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    const [pageNo, setPageNO] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [perPage, setPerPage] = useState(10);

    const getProducts = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("adminAuth");

            const response = await fetch(
                `${process.env.REACT_APP_BASEURL}/admin/admin_order_history/?page=${pageNo}&page_size=${perPage}`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        uid: userUid,
                    }),
                }
            );

            const result = await response.json();

            if (response.ok) {
                setProducts(result?.results || []);

                setTotalItem(result?.count || 0);

                setTotalPage(
                    Math.ceil((result?.count || 0) / perPage)
                );
            }

        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const updatePage = (e) => {
        const name = e.target.getAttribute("name");

        if (name === "prev") {
            if (pageNo > 1) {
                setPageNO(pageNo - 1);
            }
        } else if (name === "next") {
            if (pageNo < totalPage) {
                setPageNO(pageNo + 1);
            }
        } else {
            const page = parseInt(e.target.innerText);

            if (!isNaN(page)) {
                setPageNO(page);
            }
        }
    };

    useEffect(() => {
        if (userUid) {
            getProducts();
        }
    }, [userUid, pageNo, perPage]);



    if (loading) {
        return (
            <div className="h-full min-h-[500px] flex items-center justify-center">
                <div className="text-center">

                    <div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mx-auto"></div>

                    <p className="mt-4 text-gray-500">
                        Loading Products...
                    </p>

                </div>
            </div>
        );
    }

    return (
        <>
            <ProductListing
                products={products}
                title="Order History"
                type="wishlist"
            />

            {totalItem > 0 && (
                <Pagination
                    total={totalItem}
                    perPage={perPage}
                    currPage={pageNo}
                    prevPage={Math.max(1, pageNo - 2)}
                    tPage={totalPage}
                    updatePage={updatePage}
                    setCurrPage={setPageNO}
                    setPerPage={setPerPage}
                />
            )}
        </>
    );
};

export default OrderHistoryList;